import { $Q } from '../utils/query-selector';
import { cleanURL, initializeMethods, removePagination } from './filter';

// eslint-disable-next-line no-undef
Shopify.queryParams = {};

/**
 * Update sort_by query parameter on select change
 */
export const defultSortBySubmit = () => {
  const config = $Q('#data-config');

  $Q('#sort-by') &&
    $Q('#sort-by').addEventListener('change', ({ target }) => {
      /* eslint-disable no-undef */
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('sort_by', target.value);

      const url = cleanURL(searchParams.toString());

      window.location.search = url;

      if (!config) {
        config.dataset.currentUrlFilters = url;
      }
      /* eslint-enable no-undef */
      console.log('Changesssss');
    });
};

/**
 * Update sort_by query parameter on select change
 */
export const defultSortBy = () => {
  $Q('#sort-by') &&
    $Q('#sort-by').addEventListener('input', async ({ target }) => {
      const config = $Q('#data-config');
      removePagination();

      if (!config) return;

      const { currentUrl, currentUrlFilters, currentUrlSearch } =
        config.dataset;

      if (!currentUrl) return;

      let searchParams = new URLSearchParams(
        `sort_by=${target.value}`
      ).toString();

      if (currentUrlFilters) {
        const getCurrentFilters = new URLSearchParams(currentUrlFilters);

        if (getCurrentFilters.has('sort_by')) {
          getCurrentFilters.set('sort_by', target.value);
          searchParams = getCurrentFilters.toString();
        } else {
          searchParams = new URLSearchParams(
            `${currentUrlFilters}&sort_by=${target.value}`
          ).toString();
        }
      }

      if (currentUrlSearch) {
        searchParams = new URLSearchParams(
          `${currentUrlSearch}&${searchParams}`
        ).toString();
      }

      searchParams = cleanURL(searchParams);

      await initializeMethods({
        currentUrl,
        searchParams,
      });

      config.dataset.currentUrlFilters = searchParams;

      // > Display
      console.log('display_interaction');
      dataLayer.push({
        event: 'display_interaction',
        display_option: target.value,
      });
    });
};

/**
 * Preserve existing query parameters
 */
// eslint-disable-next-line func-names
(function () {
  /* eslint-disable no-undef */
  if (location.search.length) {
    const params = location.search.substring(1).split('&');

    for (let i = 0; i < params.length; i++) {
      const keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] =
          decodeURIComponent(keyValue[1]);
      }
    }
  }
  /* eslint-enable no-undef */
})();
